import type { RouteRecordRaw } from 'vue-router'

const authRoutesNames = {
  login: 'login',
  forgotPassword: 'forgot-password',
  newPassword: 'new-password',
  setPasswordFromEmail: 'set-password-from-email'
}

const newPasswordSubtitle = 'Please enter new password. <br/> Your password should have at least 1 uppercase letter and 1 symbol'

const authRoutes: RouteRecordRaw[] = [
  {
    path: 'login',
    name: authRoutesNames.login,
    component: () => import('@/views/auth/LoginView.vue'),
    meta: {
      title: 'Welcome!',
      subtitle: 'Please enter your credentials'
    }
  },
  {
    path: 'forgot-password',
    name: authRoutesNames.forgotPassword,
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: {
      title: 'Password Recovery',
      subtitle: 'Please enter your email address to search for your account.'
    }
  },
  {
    path: 'new-password',
    name: authRoutesNames.newPassword,

    props: { isResetPassword: true },
    component: () => import('@/views/auth/SetPasswordFromView.vue'),
    meta: {
      title: 'Password Recovery',
      subtitle: newPasswordSubtitle
    }
  },
  {
    path: 'set-password-from-email',
    name: authRoutesNames.setPasswordFromEmail,
    props: { isResetPassword: false },
    component: () => import('@/views/auth/SetPasswordFromView.vue'),
    meta: {
      title: 'Set Password',
      subtitle: newPasswordSubtitle
    }
  }
]

export {
  authRoutesNames,
  authRoutes
}
